// VIDEO_CONSTRAINTS / VIDEO_CONSTRAINTS_WITH_FPS lived here and are gone.
// They were one of four competing definitions of "the user's camera" — and the
// pair was itself the smaller version of the same problem: the one in use had
// no frame rate, and the one that did was imported by nothing. Capture
// constraints are now derived in `services/device-manager.ts` from the quality
// preset, in the single place that opens the device.

export const MIC_LEVEL_FFT_SIZE = 512
export const MIC_LEVEL_GAIN = 2.2

export const SPEAKER_TEST_SOUND_SRC = '/freesound_community-positive-response-81640.mp3'
